import React from 'react'
import { BubblesData as BData_1} from './bubbles-t1.data'
import { BubblesData as BData_2} from './bubbles-t2.data'

import Recorridos from './../../../utils/import.recor360'

import mobileAndTabletCheck from './../../../utils/mobileCheck'

import close from './../../../UI/icons/Galerias/Close.svg'
import recor360 from './../../../UI/icons/Tooltip/Recor360.svg'
import renders from './../../../UI/icons/Tooltip/Renders.svg'

let imageSize = ['100%', '100%'];
let barOffset = 0;
if(mobileAndTabletCheck() && window.innerHeight > window.innerWidth){
    barOffset = 5;
    imageSize = ['calc(84% * 1.77778)', '84%'];
}

interface Bubbles{
    BData: any,
    bubbles: any,
    btnref: any,
    array: any
}

interface Props{
    angle: number,
    show: boolean,
    tower: any,
    category: any,
    apto: any
    zoom: any,
    leftOffset: any,
    topOffset: any,
    handleGeneralGallery: any,
    handle360Click: any,
    loadingCanvas: boolean
}

interface State{
    aptos: any,
    apto: any,
    showTooltip: boolean,
    clientX: any,
    clientY: any,
    currentApto: any,
    showGallery: boolean,
    show360: boolean,
    isMouseDown: boolean,
    isMouseMoving: boolean
}

class Bubbles extends React.Component<Props, State>{
    constructor(props: Props){
        super(props)
        this.state = {
            aptos: [],
            apto: [],
            showTooltip: false,
            clientX: "",
            clientY: "",
            currentApto: "",
            showGallery: false,
            show360: false,
            isMouseDown: false,
            isMouseMoving: false
        }
    }

    componentDidMount(){
        this.BData = {
            'Torre 2': BData_1(),
            'Torre 1': BData_1(),
        }

        this.bubbles = this.BData['Torre 2']
        this.bubbles = this.BData['Torre 1']

        this.btnref = React.createRef()

        document.addEventListener("mousedown", () => {
            this.setState({
                isMouseDown: true
            })
        })
        document.addEventListener("mouseup", () => {
            this.setState({
                isMouseDown: false,
                isMouseMoving: false
            })
        })
        document.addEventListener("mouseleave", () => {
            this.setState({
                isMouseDown: false,
                isMouseMoving: false
            })
        })
        document.addEventListener("mousemove", () => {
            if(this.state.isMouseDown){
                this.setState({
                    isMouseMoving: true
                })
            }
        })
    }

    componentDidUpdate(prevProps: any){
        if(mobileAndTabletCheck() && window.innerHeight > window.innerWidth){
            barOffset = 0;
            imageSize = ['calc(84% * 1.77778)', '84%'];
        }
        else {
            imageSize = ['100%', '100%'];
            barOffset = 0;
        }

        this.updateBDataRef();

        if(prevProps.show !== this.props.show){
            this.createBubbles();
            this.forceUpdate();
        }

        if(prevProps.tower !== this.props.tower || prevProps.category !== this.props.category || prevProps.apto !== this.props.apto){
            this.createBubbles();
            this.forceUpdate();
        }

        if(prevProps.angle !== this.props.angle){
            this.createBubbles();
            this.forceUpdate();
        }
    }

    createBubbles = () => 
    {
        let angle = this.props.angle
        this.array = []

        if(!this.updateBDataRef()){           
            return;
        }
        
        if(this.bubbles[angle] === undefined){
            return this.props.angle
        }        
        
        for (let i = 0; i < this.bubbles[angle].length; i++) {

            if((this.props.apto !== "" && ("Apto Tipo " + this.props.apto) !== this.bubbles[angle][i].tipo)){
                continue;
            }           

            this.array.push(
                <polygon
                key={i} 
                points = {
                    "" + this.bubbles[angle][i].verts[0][0] + "," + this.bubbles[angle][i].verts[0][1] + " " + 
                    this.bubbles[angle][i].verts[1][0] + "," + this.bubbles[angle][i].verts[1][1] + " " + 
                    this.bubbles[angle][i].verts[3][0] + "," + this.bubbles[angle][i].verts[3][1] + " " + 
                    this.bubbles[angle][i].verts[2][0] + "," + this.bubbles[angle][i].verts[2][1]
                }
                style = {{
                    fill: (this.bubbles[angle][i].disp === "DISPONIBLE") ? "rgba(0,255,0,.3)" : 
                    (this.bubbles[angle][i].disp === "VENDIDO") ? "rgba(255,0,0,.3)" : 
                    (this.bubbles[angle][i].disp === "RESERVADO") ? "rgba(255,255,0,.3)" : 
                    (this.bubbles[angle][i].tipo === "Apto Tipo Vitta") ? "rgba(114,90,88,.7)" :
                    (this.bubbles[angle][i].tipo === "Apto Tipo Delux") ? "rgba(105,112,92,.7)" :
                    (this.bubbles[angle][i].tipo === "Apto Tipo Natural") ? "rgba(166,206,148,.7)" :
                    (this.bubbles[angle][i].tipo === "Apto Tipo Classic") ? "rgba(128,132,173,.7)" :
                    (this.bubbles[angle][i].tipo === "Apto Tipo Panoramic") ? "rgba(248,205,107,.7)" :
                    "rgba(17,78,108,.3)",

                    stroke: (this.bubbles[angle][i].disp === "DISPONIBLE") ? "rgba(0,128,0,.82)" : 
                    (this.bubbles[angle][i].disp === "VENDIDO") ? "rgba(128,0,0,.82)" : 
                    (this.bubbles[angle][i].disp === "RESERVADO") ? "rgba(128,128,0,.82)": 
                    (this.bubbles[angle][i].tipo === "Apto Tipo Vitta") ? "rgba(114,90,88,.82)" :
                    (this.bubbles[angle][i].tipo === "Apto Tipo Delux") ? "rgba(105,112,92,.82)" :
                    (this.bubbles[angle][i].tipo === "Apto Tipo Natural") ? "rgba(166,206,148,.82)" :
                    (this.bubbles[angle][i].tipo === "Apto Tipo Classic") ? "rgba(128,132,173,.82)" :
                    (this.bubbles[angle][i].tipo === "Apto Tipo Panoramic") ? "rgba(248,205,107,.82)" :
                    "rgba(17,78,108,.6)",
                    strokeWidth: 2,
                    visibility: 'visible',
                    cursor: 'pointer'
                }}

                onMouseDown = {this.showToolTip.bind(this, this.bubbles[angle][i])}
                onTouchStart = {this.showToolTip.bind(this, this.bubbles[angle][i])}
                >
                

                </polygon>
            )
            
        }
        this.forceUpdate()
    }

    showToolTip = (apto: any, e: any) => {

        this.setState({
            clientX: e.type.indexOf('touch') === 0 ? e.changedTouches[0].clientX : e.clientX, 
            clientY: e.type.indexOf('touch') === 0 ? e.changedTouches[0].clientY : e.clientY,
            apto: apto,
            showTooltip: true,
            currentApto: apto.num
        }, () => {
            console.log(this.state.apto.tipo)
            this.setState({
                show360: Object.keys(Recorridos).includes(this.state.apto.tipo),
                showGallery: apto.a && apto.a.Galeria.length > 0
            })
        })    
    }

    hideTooltip = () => {
        this.setState({
            showTooltip: false,
            apto: null
        })
    }

    updateBDataRef = () => {
        if(this.props.tower !== ''){
            this.bubbles = this.BData[this.props.tower];
        } else {
            return false;
        }
        return true
    }

    updateBubbles = (aptos: any, bubbles: any) => {
        aptos.forEach((apto: any) => {
            bubbles.forEach((frame: any) => {
                for(let bubble of frame) {
                    let count = 0;
                    if(bubble.tipo === "Apto Tipo " + apto.tipo){
                        //bubble.disp = apto.disp
                        bubble.t = apto.t
                        bubble.a = apto.a                        
                        count++;
                        if(count >= 2){
                            break;
                        }                        
                    }
                };
            })
        });
    }

    updateAvailability = (aptos: any, torre: any) => {
        this.setState({
            aptos: aptos
        }, () => {
            this.updateBubbles(this.state.aptos, this.bubbles);
            this.createBubbles();
        })

        if(this.BData[torre]){
            this.updateBubbles(aptos, this.BData[torre])
        }
    }

    render(){
        return(
            <div 
                className={this.props.show && !this.props.loadingCanvas ? "bubbles fade-in":"bubbles fade-out"}
                style = {{
                    pointerEvents: 'none',
                    width: '100%',
                    height: '100%',
                    transform: 'scale('+this.props.zoom+') translate(calc(' + this.props.leftOffset + '%), calc('+ barOffset +'% + '+ this.props.topOffset + '%))'
                }}
            >
                    <svg 
                    width={'100%'}
                    height={'100%'}
                    preserveAspectRatio="xMidYMid slice"
                    viewBox="0 0 1920 1080"
                    style={{
                        overflow: 'hidden',
                        pointerEvents: 'none',
                        position: 'absolute'
                    }}>
                        <g style={{
                            pointerEvents: this.state.isMouseDown && this.state.isMouseMoving ? "none":"visibleFill"
                        }}>
                            {this.array}
                        </g>
                        
                    </svg>

                    <div className={this.state.showTooltip ? "tooltip fade-in":"tooltip fade-out"} 
                        onMouseLeave = { this.hideTooltip.bind(this) }
                        style={{
                            left: this.state.clientX  + 'px',
                            top: this.state.clientY + 'px',
                        }}
                    >
                        <div className='close-tooltip'
                            onClick={() => {this.hideTooltip()}}
                            onTouchStart={() => {this.hideTooltip()}}
                        >
                            <img src={close}/>
                        </div>
                        <div className='tooltip-tittle'>{this.state.apto ? this.state.apto.tipo:null}</div>
                        
                        {
                            this.state.show360 || this.state.showGallery ? 
                            <React.Fragment>
                                <hr className='tooltip-hr'/>
                                <div className='multimedia-container'>
                                    {
                                        this.state.showGallery ? 
                                        <div
                                            onClick={() => {this.props.handleGeneralGallery(this.state.apto.a)}}
                                        >
                                            <img src={renders}/>
                                        </div>: null
                                    }
                                    {
                                        this.state.show360 ? 
                                        <div
                                        onClick={() => {this.props.handle360Click(this.state.apto.tipo)}}
                                        >
                                            <img src={recor360}/>
                                        </div>: null
                                    }
                                </div>
                            </React.Fragment>:null
                        }
                    </div>
            </div>
        )
    }
}

export default Bubbles